require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-four-of-the-ten-best-jobs-in-america-related-to-coding.json") })
        }
      }, "path---blog-four-of-the-ten-best-jobs-in-america-related-to-coding");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-four-of-the-ten-best-jobs-in-america-related-to-coding!./.cache/json/blog-four-of-the-ten-best-jobs-in-america-related-to-coding.json
// module id = 824
// module chunks = 231608221292675